import Vue from 'vue'
Vue.directive('loadmore',{

  bind: function(el, binding) {
    let loadSign = true
    // el.addEventListener('scroll', () => {
    //     console.log('el.scrollHeight', el.scrollHeight)
    //   if (el.scrollHeight - (el.scrollTop + el.clientHeight) < 300) {
    //     // 触发指令绑定的函数
    //     binding.value()
    //     alert(1)
    //   }
    // })
    window.addEventListener("scroll", function () {
      let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      //文档高度
      let bodyHeight = document.body.scrollHeight ||  document.documentElement.scrollHeight;
      // console.log('window.innerHeight', window.innerHeight)
      // console.log('bodyHeight',bodyHeight)
      if (scrollTop + window.innerHeight >= bodyHeight - 50 && loadSign && bodyHeight>200) {
        loadSign = false
        // 触发指令绑定的函数
        binding.value()
        setTimeout(()=>{
          loadSign = true
        },1000)
      }

    })
  }


})




// WEBPACK FOOTER //
// ./src/directive/loadMore.js